import * as React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';
import Input from 'components/inputs/input/Input';

import { __t, applyTranslations } from 'utils/language';

import './brand-profile-approval-actions-modal.scss';

applyTranslations(require('./brand-profile-approval-actions-modal.i18n.json'));

type Props = {
  updateExternalReasonState: (text: string) => void,
  campaignsWithUnreleasedPayouts: Array<number>
}

const MSG_KEY = 'brand_profile_approval_actions_modal';

const BrandProfileApprovalActionsModal = (props: Props) => {
  const { updateExternalReasonState, campaignsWithUnreleasedPayouts } = props;
  const [externalReason, setExternalReason] = React.useState('');

  const handleReasonChanged = (event) => {
    const text = event.currentTarget.value;
    updateExternalReasonState(text);
    setExternalReason(text);
  };

  const modalClasses = classnames('brand-profile-approval-actions-modal', {
    'brand-profile-approval-actions-modal--is-centered': campaignsWithUnreleasedPayouts.length < 5
  });

  const msg = __t(`${MSG_KEY}.unreleased_payouts`, {
    numCampaigns: campaignsWithUnreleasedPayouts.length,
    withPlural: campaignsWithUnreleasedPayouts.length
  });

  return (
    <React.Fragment>
      <div className={modalClasses}>
        <div className="brand-profile-approval-actions-modal__message">
          {msg}:
        </div>
        {
          campaignsWithUnreleasedPayouts.map((campaignId, index) => (
            <React.Fragment key={`payout-campaign-${campaignId}`}>
              <a
                href={`/campaigns/${campaignId}/payments`}
                target="_blank"
                rel="noopener noreferrer"
                className="brand-profile-approval-actions-modal__link"
              >
                {campaignId}
              </a>
              {
                index < campaignsWithUnreleasedPayouts.length - 1 && (
                  <div className="brand-profile-approval-actions-modal__separator">
                    ,
                  </div>
                )
              }
            </React.Fragment>
          ))
        }
      </div>
      <VerticalSpacing type="medium" />
      <Input
        multiline
        width="responsive"
        value={externalReason}
        placeholder={__t(`${MSG_KEY}.approval_status_placeholder`)}
        onChange={handleReasonChanged}
      />
    </React.Fragment>
  );
};

export default connect()(BrandProfileApprovalActionsModal);
